export const createLink = (
  blob: Blob,
  filename: string,
  action: 'download' | 'print' = 'download'
): HTMLAnchorElement => {
  const link = document.createElement('a')
  link.href = window.URL.createObjectURL(blob)
  link.setAttribute(action, filename)
  link.setAttribute('data-cy', `created-${action}-link`)
  link.target = '_blank'
  document.body.appendChild(link)

  return link
}
